// «VAS A COBRAR SIN SEÑAL.» · DIRECTRIZ-PWA F2 (11 oct 2026, DISENO-F2 §4.8).
//
// Arriba del modal de cobro cuando no hay señal y la empresa tiene
// encendido «Cobrar sin señal». Dice las tres cosas que quien cobra tiene
// que saber antes de confirmar: dónde queda la venta, cuándo recibe folio
// y qué pasa si para entonces no hay existencia.
import { CloudOff } from 'lucide-react';
import Ayuda from '../../ui/Ayuda';

export default function AvisoCobroSinSenal() {
  return (
    <div role="status" className="rounded-xl border border-amber-300 bg-amber-50 p-3 text-sm text-amber-900">
      <p className="flex items-start gap-2">
        <CloudOff className="mt-0.5 h-5 w-5 shrink-0" aria-hidden="true" />
        <span className="min-w-0 break-words">
          <strong>Vas a cobrar sin señal.</strong>{' '}
          La venta se guarda en este teléfono y se envía sola al volver la señal; el folio lo da TEGO entonces.
          Si para entonces ya no hay existencia, la venta quedará <strong>por revisar</strong> y tendrás que ajustarla.
        </span>
      </p>
      <Ayuda id="pwa.pos.cobrar_sin_senal" />
    </div>
  );
}
